/* eslint-disable no-unused-vars */
import React from 'react'
import moment from 'moment/min/moment-with-locales'
import Modal, { ModalBody } from './modal'
import { useMembershipNotification } from '../hooks/use-membership-notification'
import { ButtonGhost, ButtonPrimary } from './button-styled'
import styled from '@emotion/styled'

moment.locale('id')

const ExpiredBadge = styled.span`
  display: inline-block;
  background: #ffe8e8;
  color: #d60000;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
`

export default function AccountExpiredModal() {
  const { account, shouldShow, status, onClose } = useMembershipNotification()

  if (!shouldShow || !status) return null

  // Moment fallback → cegah "Invalid date"
  const getFormattedDate = date => {
    if (!date) return '-'
    const m = moment(date)
    return m.isValid() ? m.format('DD MMMM YYYY') : '-'
  }

  const formattedDate = getFormattedDate(account?.dateExpired)

  const title =
    status === 'expired'
      ? 'Masa Aktif Akun Kamu Sudah Berakhir !'
      : 'Masa Aktif Hampir Berakhir !'

  const message =
    status === 'expired' ? (
      <p>
        Akses ke video tutorial & webinar telah dihentikan. Masa aktif akun kamu
        berakhir pada <ExpiredBadge>{formattedDate}</ExpiredBadge>. Silakan
        perpanjang akun untuk mengaktifkan kembali fasilitas.
      </p>
    ) : (
      <p>
        Masa aktif akun kamu akan berakhir pada{' '}
        <ExpiredBadge>{formattedDate}</ExpiredBadge>. Segera perpanjang agar
        tetap bisa mengakses video tutorial & webinar.
      </p>
    )

  const goToMembership = () => {
    onClose()
    setTimeout(() => {
      // window.location.href = '/membership'
      // Baleomol it's Over
      window.location.href = '#'
    }, 50)
  }

  return (
    <Modal
      open={shouldShow}
      onClose={onClose}
      disableOutsideClick
      header={{ text: title }}
    >
      <ModalBody>
        {message}

        <div
          style={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'end',
            gap: '10px',
            flexWrap: 'wrap',
          }}
        >
          {/* <ButtonGhost
            onClick={goToMembership}
            variant='contained'
            size='small'
          >
            Perpanjang Sekarang
          </ButtonGhost> */}

          <ButtonPrimary onClick={onClose} variant='outlined' size='small'>
            Oke, Mengerti
          </ButtonPrimary>
        </div>
      </ModalBody>
    </Modal>
  )
}
